export default {
  list: [
    {
      value: 'true',
      title: 'قابل مشاهده'
    },
    {
      value: 'false',
      title: 'غیرقابل مشاهده'
    },
    {
      value: 'null',
      title: 'هردو'
    },
  ],
  values: {
    BOTH: 'BOTH',
    VIEWABLE: 'VIEWABLE',
    NOT_VIEWABLE: 'NOT_VIEWABLE'
  }
}